import {defineAsyncComponent} from 'vue'
const BasicsRouter = [
  // 个人设置
  {
    path: 'profile',
    name: 'KeywordProfile',
    component: () => import('@/views/Basic/KeywordProfile/Index.vue'),
    meta: {
      key: 'basic'
    },
  },
  // 博主管理
  {
    path: 'bloggers',
    name: 'KeywordUsers',
    component: () => import('@/views/Basic/KeywordUsers/Index.vue'),
    meta: {
      key: 'basic'
    },
  },
  // 博主管理-新版
  {
    path: 'users/bloggers',
    name: 'KeywordUsersBloggers',
    component: () => import('@/views/Basic/KeywordUsers/IndexBlogger.vue'),
    meta: {
      key: 'basic'
    },
  },
  // 博主详情
  {
    path: 'users/bloggersdetails',
    name: 'BloggerDetail',
    component: () => import('@/views/Basic/KeywordUsers/BloggerDetail.vue'),
    meta: {
      key: 'basic'
    },
  },
  // 团长管理
  {
    path: 'directors',
    name: 'KeywordDirectors',
    component: () => import('@/views/Basic/KeywordDirectors/Index.vue'),
    meta: {
      key: 'basic'
    },
  },
]
export {BasicsRouter}
